import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import Header from "../DefaultLayout/Header";
import LoggedHeader from "../DefaultLayout/LoggedHeader";
import { connect } from "react-redux";
import { loadUser } from "../actions/authActions";
import DashboardNavbar from "./DashboardNavbar";
import { useDispatch } from "react-redux";


const FreeRegistrationSection = (props) => {
  const isAuth = props.auth.isAuthenticated;
  const { frontLabelsName } = props.label;
  const dispatch = useDispatch();

  return (
    <Container className="free-registration p-0 d-flex flex-column">
      {isAuth ? <LoggedHeader /> : <Header />}
      <DashboardNavbar/>
      <div className="d-flex align-items-center free-registration-col free-regis">
        <label className="free-registration-text pt-2">
          {frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_free_registration")
              .length > 0
              ? frontLabelsName.filter((e) => e.key == "lbl_free_registration")[0][
              "value"
              ] || "lbl_free_registration"
              : "lbl_free_registration"
            : "lbl_free_registration"}
        </label>
        <h6 className="free-registration-subtext ps-2 pe-2 cursor-style">
          {frontLabelsName
            ? frontLabelsName.filter((e) => e.key == "lbl_free_register_info")
              .length > 0
              ? frontLabelsName.filter((e) => e.key == "lbl_free_register_info")[0][
              "value"
              ] || "lbl_free_register_info"
              : "lbl_free_register_info"
            : "lbl_free_register_info"}
        </h6>
        {/* /subscribe-in-renter-list/non-registered-user */}
        <Row className="d-flex align-items-center justify-content-center pt-2">
          <Col
            sm="12"
            md=""
            className=" d-flex align-items-center justify-content-center mt-2"
          >
                  <div className="chat-tooltip">
            <Link to="/access-by-otp" onClick={()=>{
                 dispatch({
                  type: "SET_IS_SUBSCRIBING",
                  payload: { isSubscribing: false },
                });
              localStorage.setItem("isSubscribing",false)}}>
              <Button className="sign-me-tenant-list sign-me-tenant-list12" type="button">
                {frontLabelsName
                  ? frontLabelsName.filter(
                    (e) => e.key == "lbl_sign_me_up_for_tenant"
                  ).length > 0
                    ? frontLabelsName.filter(
                      (e) => e.key == "lbl_sign_me_up_for_tenant"
                    )[0]["value"] || "lbl_sign_me_up_for_tenant"
                    : "lbl_sign_me_up_for_tenant"
                  : "lbl_sign_me_up_for_tenant"}


              </Button>

            
            </Link>
            <span class="tooltiptextaae" style={{color:"black",lineHeight:"20px",padding:"6px 7px",fontSize:"15px"}}>  
              {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_here_you_can_register_for_free_on_the_tenant_register_and_have_the_landlord_find_you")
                    .length > 0
                    ? frontLabelsName.filter(
                      (e) => e.key == "lbl_here_you_can_register_for_free_on_the_tenant_register_and_have_the_landlord_find_you"
                    )[0]["value"] || "lbl_here_you_can_register_for_free_on_the_tenant_register_and_have_the_landlord_find_you"
                    : "lbl_here_you_can_register_for_free_on_the_tenant_register_and_have_the_landlord_find_you"
                  : "lbl_here_you_can_register_for_free_on_the_tenant_register_and_have_the_landlord_find_you"}
                 </span>
              </div>
          </Col>
          <Col
            sm="12"
            md=""
            className=" d-flex align-items-center justify-content-center mt-2"
          >
             <div className="chat-tooltip">
            <Link to={"/landlords/register-type"}>
              <Button className="register-me-tenant-list sign-me-tenant-list12">
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_register_property")
                    .length > 0
                    ? frontLabelsName.filter(
                      (e) => e.key == "lbl_register_property"
                    )[0]["value"] || "lbl_register_property"
                    : "lbl_register_property"
                  : "lbl_register_property"}
              </Button>

            </Link>
            <span class="tooltiptextaae" style={{color:"black",lineHeight:"20px",padding:"6px 7px",fontSize:"15px"}}>  
              {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_here_landlords_can_register_their_apartment_on_Legulistinn_for_free")
                    .length > 0
                    ? frontLabelsName.filter(
                      (e) => e.key == "lbl_here_landlords_can_register_their_apartment_on_Legulistinn_for_free"
                    )[0]["value"] || "lbl_here_landlords_can_register_their_apartment_on_Legulistinn_for_free"
                    : "lbl_here_landlords_can_register_their_apartment_on_Legulistinn_for_free"
                  : "lbl_here_landlords_can_register_their_apartment_on_Legulistinn_for_free"}
                 </span>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  label: state.language,
});

export default connect(mapStateToProps, {
  loadUser,
})(FreeRegistrationSection);
